import React, { Component } from 'react'
import Axios from 'axios'
import CircularDeterminate from '../_Components/CircularDeterminate'
import Logo from '../Img/logo.png';
import ReactToPrint from 'react-to-print';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Parse from 'html-react-parser';
import Pdf from "react-to-pdf";





class PrinterPage extends Component {
    //add new printer
    constructor(props) {
        super(props);
        this.state = {
            pedido: null,
            captura: "",
            id: 0,
            parametros: null
        }
        this.CapturaParametrosUrl()
        this.printar = this.printar.bind(this)
        this.getParametros()
    }

    componentDidMount() {
        setTimeout(this.printarPagina, 2000)
    }

    async printarPagina() {
        window.print()

    }

    async getParametros() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.get('parametros/get-premios')
            this.setState({ parametros: response.data })
        } catch (err) {
            console.log(err)
        }
    }

    

    CapturaParametrosUrl() {

        //captura a url da página
        var url = window.location.href;

        //tenta localizar o ?
        var res = url.split('?');

        if (res[1] === undefined) {
            alert('página sem parâmetros.');
        }

        if (res[1] !== undefined) {
            //tenta localizar os & (pode haver mais de 1)
            var parametros = res[1].split('&');

            //qtd. de parâmetros que serão tratados pelo laço.
            var qtdParametrosParaLer = 5;

            //guarda o nome dos parâmetros e os valores e, vetores.
            var parametroEncontrado = new Array();
            var valorParametro = new Array();

            for (var cont = 0; cont <= qtdParametrosParaLer; cont++) {
                if (parametros[cont] !== undefined) {
                    this.setState({ captura: parametros[cont].split('=') })
                    this.state.captura = parametros[cont].split('=');
                    this.setState({ id: this.state.captura[1] });
                    this.state.id = this.state.captura[1];


                    parametroEncontrado[cont] = this.state.captura[0];
                    valorParametro[cont] = this.state.captura[1];
                    this.getPedido()
                }
            }
        }
    }

    getPedido = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.post('pedidos/id', {
                id: this.state.id
            })

            window.localStorage.setItem('printItem', JSON.stringify(response.data))
            this.setState({ pedido: response.data })
            console.log(this.state.pedido)
        } catch (err) {
            console.log(err)
        }
    }

    printar() {
        window.location.to = "gonative://share/sharePage"
    }


    formatDate(data) {
        return moment(data).add(0, 'days').format('DD-MM-YYYY')
    }


    render() {
        const ref = React.createRef();
        const options = {
            orientation: 'landscape',
            unit: 'in',
            format: [4,2]
        };

        if (this.state.pedido != null && this.state.parametros){
            if(!this.state.parametros.modoRifa){
            return (
                <div>
                <Pdf targetRef={ref} filename="sorteflash.pdf" x={window.innerWidth > 400? 1 : 75} y={-10} scale={window.innerWidth > 400? 0.52 : 0.6} >
                {({ toPdf }) => <button className="w-100 btn-fill btn btn-warning"  onClick={toPdf}>Downdload PDF</button>}
              </Pdf>
                <div ref={ref} >
                    <div class="text-center justify-content-center">
                        {/* <div class='row justify-content-center'><h1 className="barcode">{cartela.codigo}</h1></div> */}
                        <div class='row justify-content-center'><img style={{ maxWidth: "50%", minWidth: "50%" }} src={Logo} /></div>
                        <div class='row justify-content-center text-center'><span class="font-weight-bold text-dark" >SORTEIO - {this.formatDate(this.state.pedido.cartelas[0].data)} - {this.state.pedido.cartelas[0].horario ? this.state.pedido.cartelas[0].horario : '10:00'} </span></div>
                    </div>
                    <div class="row pl-3 m-0" ><span class="font-weight-bold" style={{ margin: '0' }}>Nome: {this.state.pedido.clienteId.nome}</span></div>
                    <div class="row pl-3 m-0" ><span class="font-weight-bold" style={{ margin: '0' }}>Contato: {this.state.pedido.clienteId.telefone}</span></div>
                    <div class="row pl-3 m-0" ><span class="font-weight-bold" style={{ margin: '0' }}>Endereco: {this.state.pedido.clienteId.endereco} - {this.state.pedido.clienteId.bairro} - {this.state.pedido.clienteId.cidade} -  {this.state.pedido.clienteId.estado}</span></div>
                    <div class="row pl-3 m-0" ><span class="font-weight-bold" style={{ margin: '0' }}>Vd: {this.state.pedido.cambistaId ? this.state.pedido.cambistaId.nome : 'SorteFlash Online'}</span></div>
                    <hr style={{ borderBottom: '2px dotted black', borderRadius: '2px', minWidth: '100%' }}></hr>

                    <div class='row justify-content-center'><img style={{ maxWidth: "50%", minWidth: "50%" }} src={Logo} /></div>
                    {/* <div class='row rounded bg-dark text-light text-center justify-content-center '><h5 class="font-weight-bold" style={{ margin: '0' }}><span><i class="fa fa-youtube-play mr-3" aria-hidden="true"></i>LIVE NO YOUTUBE</span></h5></div> */}
                    <div class='row justify-content-center text-center '><span class="font-weight-bold text-dark" >SORTEIO - {this.formatDate(this.state.pedido.cartelas[0].data)} - {this.state.pedido.cartelas[0].horario ? this.state.pedido.cartelas[0].horario : '10:00'} </span></div>
                    <div class=" text-dark  w-100 text-center" style={{ display: 'flex', flexDirection: 'column' }}>
                        {Parse(this.state.parametros?.premios)}
                    </div>

                    <div class='row  justify-content-center text-center ' style={{ fontSize: '0.85em' }}><span class="ml-3 font-weight-bold" >Vendedor: {this.state.pedido.cambistaId ? this.state.pedido.cambistaId.nome : 'SorteFlash Online'}</span> </div>
                    {this.state.pedido.cartelas ?
                        this.state.pedido.cartelas.map((cartela, index) => {
                            return (

                                <div
                                    class="mb-2 w-100 rounded"


                                >

                                    <div class="container text-dark border border-dark">
                                        <div class="row pt-3 border border-dark text-center justify-content-center" >
                                            <h5 class='text-center '><span class="font-weight-bold" style={{ fontSize: '1em' }}>R$: {cartela.valor} -  Cartela: {cartela.codigo}</span></h5>
                                        </div>
                                        <div class="row border border-dark">
                                            <div class='col border border-dark text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[0]}</span>
                                            </div>
                                            <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[1]}</span>
                                            </div>
                                            <div class='col border border-dark text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[2]}</span>
                                            </div>
                                            <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[3]}</span>
                                            </div>
                                            <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[4]}</span>
                                            </div>
                                        </div>
                                        <div class="row border border-dark">
                                            <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[5]}</span>
                                            </div>
                                            <div class='col border  border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[6]}</span>
                                            </div>
                                            <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[7]}</span>
                                            </div>
                                            <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[8]}</span>
                                            </div>
                                            <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[9]}</span>
                                            </div>
                                        </div>
                                        <div class="row border border-dark">
                                            <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[10]}</span>
                                            </div>
                                            <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[11]}</span>
                                            </div>
                                            <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[12]}</span>
                                            </div>
                                            <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[13]}</span>
                                            </div>
                                            <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                                                <span class="p2" style={{ fontSize: '1.5em' }}>{cartela.numeros[14]}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            )
                        })


                        : ""}


                </div>
                </div>
            );
        }
        else {
            return (
            <div>
                <Pdf targetRef={ref} filename="sorteflash.pdf" x={window.innerWidth > 400? 1 : 75} y={-10} scale={window.innerWidth > 400? 0.52 : 0.6} >
                {({ toPdf }) => <button className="w-100 btn-fill btn btn-warning"  onClick={toPdf}>Downdload PDF</button>}
                </Pdf>
                <div ref={ref}>
                    {this.state.pedido.cartelas.map((cartela, index) => {
                        <h1>HELLO WORLD</h1>
                    })}
                </div>
          </div>);
        }
        }
        else {
            return <div><h1><CircularDeterminate max={100} /></h1></div>
        }
    }

}




class Example extends React.Component {
    render() {
        return (
            <div>
                {/* <ReactToPrint
                    trigger={() => <Link className="w-100 btn-fill btn btn-danger" to="#">Imprimir</Link>}
                    content={() => this.componentRef}
                /> */}
                <PrinterPage ref={el => (this.componentRef = el)} />
            </div>
        );
    }
}

export default Example;
